if(typeof aws-sdk === 'undefined') { var e = new Error("Cannot find module 'aws-sdk'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = aws-sdk;